import React, { Component } from "react";
import axios from "axios";
import { baseURL } from "../../config";
import CabTrackView from "./index";

const POLL_INTERVAL_MS = 30 * 1000;
// Nothing changes after these, so polling stops
const FINAL_STATES = ["COMPLETED", "INVALID"];

// GET /cab-tracking/:id without the shared Fetch, which toasts every error:
// these pages poll, and need to tell a bad link from a failed request.
// Resolves { data } | { state: "INVALID" | "OFFLINE" | "ERROR" }.
export const fetchCabTracking = async (cabBookingGroupId, query = "") => {
  try {
    const response = await axios.get(
      `${baseURL}/cab-tracking/${cabBookingGroupId}${query}`
    );
    const { statusCode, data } = response.data || {};
    if (statusCode === "ok" && data && data.state) return { data };
    if (data === "Invalid tracking link") return { state: "INVALID" };
    return { state: "ERROR" };
  } catch (error) {
    const offline = typeof navigator !== "undefined" && !navigator.onLine;
    return { state: offline ? "OFFLINE" : "ERROR" };
  }
};

// Fetches and polls one cab's tracking data and renders it.
// Used by the public /cab-track page and the Self Help Page (cab legs).
class CabTracker extends Component {
  state = {
    state: "LOADING",
    location: null,
    eta: null
  };

  componentDidMount() {
    this.fetchData();
    this.pollTimer = setInterval(this.fetchData, POLL_INTERVAL_MS);
  }

  componentWillUnmount() {
    clearInterval(this.pollTimer);
    this.unmounted = true;
  }

  fetchData = async () => {
    const { cabBookingGroupId, pickupStationId, dropStationId } = this.props;
    // A passenger's own boarding and drop stops (SHP). Without them the cab's
    // pickups, then drops, are shown in order.
    const params = new URLSearchParams();
    if (pickupStationId) params.set("pickupStationId", pickupStationId);
    if (dropStationId) params.set("dropStationId", dropStationId);
    const query = params.toString() ? `?${params}` : "";
    const result = await fetchCabTracking(cabBookingGroupId, query);
    if (this.unmounted) return;

    if (result.data) {
      this.setState({
        state: result.data.state,
        location: result.data.location,
        eta: result.data.eta
      });
    } else if (result.state === "INVALID" || this.state.state === "LOADING") {
      // A failed refresh keeps the last data on screen (the banner flags a
      // stale location); only a first load without data shows the error
      this.setState({ state: result.state });
    }

    if (FINAL_STATES.includes(this.state.state)) {
      clearInterval(this.pollTimer);
    }
  };

  render() {
    const { state, location, eta } = this.state;
    return (
      <CabTrackView
        fullScreen
        state={state}
        locations={location ? [location] : []}
        eta={eta}
      />
    );
  }
}

export default CabTracker;
